import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { RoleEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createListRolesUseCase({ membershipRepository }: Deps) {
  return async function listRoles(orgId: string): Promise<RoleEntity[]> {
    return membershipRepository.listRoles(orgId);
  };
}
